/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from "react";

//vlinder libs
import { LoggerModule } from "@vlinder-web/logger-module-react";

const log: any = LoggerModule?.getInstance();

export const getCredentialVerified = (
  fullProvenance: any,
  provenanceCredTxId: string,
  verifyCredData: any
) => {
  log.info(` in getCredentialVerified :`, fullProvenance, provenanceCredTxId, verifyCredData);
  let _res: any[];
  _res =
    fullProvenance &&
    Array.isArray(fullProvenance) &&
    fullProvenance.length > 0 &&
    fullProvenance.map((item: any, index: number) => {
      let _data = item?.data;
      let matched = false;
      let _temp =
        _data &&
        Array.isArray(_data) &&
        _data.length > 0 &&
        _data.map((ele: any, index: number) => {
          console.log(`ele in getCred :`, ele);
          if (ele?.credTxId === provenanceCredTxId) {
            return {
              ...ele,
              isVerified: true,
              ...verifyCredData,
            };
          } else if (ele?.isVerified) {
            return { ...ele };
          } else {
            return {
              ...ele,
              isVerified: false,
            };
          }
        });
      if (_temp) {
        return {
          ...item,
          data: _temp,
        };
      } else if (item?.credTxId === provenanceCredTxId) {
        return {
          ...item,
          isVerified: true,
          ...verifyCredData
        };
      } else if (item?.isVerified) {
        return { ...item };
      } else {
        return { ...item, isVerified: false };
      }
    });
  log.success("in getCredentialVerified on verified modication :", _res);

  return _res;
};
